import type { ValidatedKey } from '@festina-life/core'
import get from 'lodash-es/get'

import { useFormikContext } from './useFormikContext'

const hasNonEmptyError = (error: unknown): boolean => {
  if (typeof error === 'string') {
    return !!error
  }

  if (error && typeof error === 'object') {
    return Array.isArray(error)
      ? error.some(hasNonEmptyError)
      : Object.values(error).some(hasNonEmptyError)
  }

  return false
}

const hasTouchedAndError = (error: unknown, touched: unknown): boolean => {
  if (typeof error === 'string') {
    return !!error && touched === true
  }

  if (error && typeof error === 'object') {
    return Array.isArray(error)
      ? error.some((nestedError, index) =>
          hasTouchedAndError(nestedError, get(touched, index)),
        )
      : Object.entries(error).some(([key, nestedError]) =>
          hasTouchedAndError(nestedError, get(touched, key)),
        )
  }

  return false
}

export const useFormikFieldArrayItemError = (name: ValidatedKey) => {
  const { errors, touched, submitCount, status } = useFormikContext()

  return (index: number) => {
    const arrayError = get(errors, name)
    if (arrayError && typeof arrayError === 'string') {
      return false
    }

    const fieldName = `${name}.${index}`
    const error = get(errors, fieldName)
    const fieldTouched = get(touched, fieldName)

    return submitCount > 0 || status?.hasFormValidated === true
      ? hasNonEmptyError(error)
      : hasTouchedAndError(error, fieldTouched)
  }
}
